<template>
  <input
    type="date"
    class="form-control"
    v-model="value"
    :disabled="disabled"
    :required="schema.required"
  />
</template>

<script>
// vue-form-generator's own `inputType: "date"` never writes the model directly:
// its setter delegates to a debounced formatter that only exists once mounted()
// ran on that instance. On a reused instance it stays null and typing throws
// "debouncedFormatFunc is not a function", silently dropping the value.
// This field keeps abstractField's plain setter, so v-model just works.
import { abstractField } from "vue-form-generator";

export default {
  name: "FieldDateNative",
  mixins: [abstractField],
};
</script>
